/**
 * Routes that render without the site's global chrome.
 *
 * The navbar, announcement banner, breadcrumbs, back-to-top and footer all
 * live in `App.tsx` around the router, not inside the pages, so a page cannot
 * opt out of them on its own. This is the single list that says which ones do.
 *
 * `/lp` is the paid-campaign landing page: every link out of it is a way to
 * lose the visitor before they reach the form, so it carries no site
 * navigation at all and supplies its own minimal legal strip instead of the
 * full footer. `/thank-you` is where that form lands, so it gets the same
 * treatment — it is the end of the same funnel, not a page of the site.
 * `/student-stories` is the same funnel's social-proof-and-booking page.
 *
 * Admin keeps its own separate check in `AppChrome` — it has a whole layout,
 * not just a missing header.
 */
const CHROMELESS_ROUTES = ["/lp", "/llp", "/thank-you", "/student-stories"];

/**
 * Compared lowercased. The router matches paths case-insensitively, so
 * `/Student-Stories`, `/student-stories` and `/STUDENT-STORIES` all render the
 * same page — and this has to agree, or the capitalised address that campaigns
 * link to would render the page with the full site navbar and footer around it.
 */
export const isChromelessRoute = (pathname: string): boolean => {
  const path = pathname.toLowerCase();
  return CHROMELESS_ROUTES.some((route) => path === route || path.startsWith(`${route}/`));
};
